import { render, staticRenderFns } from "./PurchasePaymentChecklist.vue?vue&type=template&id=b1152baa"
import script from "./PurchasePaymentChecklist.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports